export default __webpack_public_path__ + "static/media/logo.d0cbc34c.png";